import axios from 'axios';
import QueryString from 'qs';
import { generateQueryParams } from 'utils/generateQueryParams';

export const ClientsService = {
  async getClients(page, perPage, filters, groups, tribe_id) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
      tribe_id: tribe_id === 3 ? null : tribe_id,
    });

    if (groups.length > 0) {
      params.group_ids = groups;
    }

    const res = await axios.get('org/v1/clients/', {
      params,
      paramsSerializer: (params) => {
        return QueryString.stringify(params, { arrayFormat: 'repeat' });
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientsSelect(page, size, search, clientId, groups, tribe_id) {
    const params = generateQueryParams({
      page,
      size,
      search,
      client_id: clientId,
      tribe_id,
    });

    if (groups && groups.length > 0) {
      params.group_ids = groups;
    }

    const res = await axios.get('org/v1/clients/all/select/', {
      params,
      paramsSerializer: (params) => {
        return QueryString.stringify(params, { arrayFormat: 'repeat' });
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getSearchedClients(search, clientIds, tribe_id) {
    const params = generateQueryParams({
      search,
      client_ids: clientIds,
      tribe_id: tribe_id === 3 ? null : tribe_id,
    });

    const res = await axios.get('org/v1/clients-search-select/', {
      params,
      paramsSerializer: (params) => {
        return QueryString.stringify(params, { arrayFormat: 'repeat' });
      },
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientsOfSegment(page, perPage, segmentId) {
    const params = generateQueryParams({
      page,
      size: perPage,
    });

    const res = await axios.get(`org/v1/segment/clients/${segmentId}/`, {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientDetail(id) {
    const res = await axios.get(`org/v1/clients/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientCategoriesList() {
    const res = await axios.get(`/clientcategories/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getParks() {
    const res = await axios.get('/get-parks/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientAdditionalInfo(id) {
    const res = await axios.get(`org/v1/additionalInfo/${id}/`);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientAdditionalInfoTypes() {
    const res = await axios.get('org/v1/additionalInfo_types/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async updateClientAdditionalInfo(payload, id) {
    const res = await axios.put(`org/v1/additionalInfo/${id}/`, payload);

    if (res.status === 200) {
      return true;
    }

    return Promise.reject();
  },

  async createClient(payload) {
    const res = await axios.post(`v1/client/crm-registration/`, payload);

    if (res.status === 201) {
      return res.data;
    }

    return Promise.reject();
  },

  async updateClient(payload, id) {
    const res = await axios.put(`org/v1/clients/${id}/`, payload);

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },

  async getClientsLogs(page, perPage, filters) {
    const params = generateQueryParams({
      page,
      size: perPage,
      ...filters,
    });

    const res = await axios.get('rbac/v1/payda/logs/', {
      params,
    });

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
};
